import WidgetHub from "@/components/WidgetHub";
import { Factory, ShoppingCart, Flame } from "lucide-react";

export default function ProductionHub() {
  const widgets = [
    { label: "Sales orders queue", description: "Orders raised by Sales — production status", to: "/org/production/orders", icon: ShoppingCart, accent: "bg-orange-500/10" },
    { label: "Production runs", description: "Active production orders & stages", to: "/org/production/runs", icon: Factory },
    { label: "Kiln & lines", description: "G-Prep / G-Line / Polishing / Kiln", to: "/org/production/lines", icon: Flame, accent: "bg-rose-500/10" },
  ];
  return <WidgetHub title="Production" subtitle="Sales-order pipeline, production runs, kiln lines — under Production Manager." widgets={widgets} testid="production-hub" />;
}
